import { createContext } from 'react';
import { SubmitCallback, SubmitInput } from './types';

export const DigtectiveContext = createContext({
  submitWithDigger: (input: SubmitInput, callback: SubmitCallback) => {}
});
